import { memo, useEffect, useState } from 'react'
import { useTranslate } from '../../../../../hooks/language/use-translate'

export const MessageSupport = memo(() => {
  const [shouldShow, setShouldShow] = useState(true)

  const { translate } = useTranslate()

  useEffect(() => {
    // if (!liveSetting?.messagePinnedChat) {
    const timeoutId = setTimeout(() => {
      setShouldShow(false)

      clearTimeout(timeoutId)
    }, 5000)
    // }
  }, [])
  // }, [liveSetting?.messagePinnedChat])

  if (!shouldShow) {
    return null
  }

  return (
    <div
      className="min-h-10 flex flex-row p-2.5 overflow-hidden rounded-[14px] w-72"
      style={{
        backgroundImage: 'linear-gradient(to right, #9B30E68C, #5B2E9E8C)',
        border: '1px solid rgba(199, 125, 255, 0.2)',
      }}
    >
      <span className="break-all text-[13px] leading-[18px] text-white/95">
        {translate('chat-live-message-support')}
      </span>
    </div>
  )
})
